import routes from './routes';
const constants = {
    ROUTES: routes,
};
export default constants;

export const ROUTES = routes;
